export default __webpack_public_path__ + "static/media/WM0350.34I-41333_-24652_0.3e03434d.jpg";